import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteMeta,
} from "vue-router";
import header from "@/layout/header.vue";
import { userStore } from "@/stores/modules/user";
import { login } from "@/utils/login";
import { ElMessage } from "element-plus";
import { workplace } from "./workplace";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/tree/:id",
    name: "tree",
    components: {
      default: () => import("@/views/exibition/tree.vue"),
    },
    meta: {
      back: {
        url: "/workplace",
      },
      requiresAuth: false,
    },
  },
  {
    path: "/exibitionEdit/:id",
    name: "exibitionEdit",
    components: {
      default: () => import("@/views/exibition/exibition.vue"),
    },
    meta: {
      // back: {
      //   url: "/workplace/history",
      // },
      header: false,
    },
  },
  // {
  //   path: "/exibitionEdit",
  //   name: "exibitionEdit",
  //   components: {
  //     default: () => import("@/views/edit.vue"),
  //     header,
  //   },
  // },
  {
    path: "/business",
    components: {
      default: () => import("@/views/business/index.vue"),
    },
    children: [
      {
        path: "/",
        name: "business",
        component: () => import("@/views/business/index.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "tree",
        name: "businessTree",
        component: () => import("@/views/exibition/tree.vue"),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/inviteState",
    components: {
      default: () => import("@/views/inviteState.vue"),
      header,
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/preview/:id",
    name: "workPlace-preview",
    components: {
      default: () => import("@/views/workplace/previewIframe.vue"),
    },
    meta: {
      menu: false,
      header: false,
      requiresAuth: false,
      back: true,
    },
  },

  // {
  //   path: "/micro",
  //   name: "microIeds",
  //   components: {
  //     default: () => import("@/views/edit.vue"),
  //     header,
  //   },
  // },
  // {
  //   path: "/micro/*",
  //   name: "microIeds1",
  //   components: {
  //     default: () => import("@/views/edit.vue"),
  //     header,
  //   },
  // },
  {
    path: "/micro/:pathMatch(.*)*",
    name: "microIeds",
    components: {
      // component: () => import("@/views/workplace.vue"),
      // default: () => import("@/views/edit.vue"),
      default: () => {
        return {
          template: "<div id='qiankun_u111'><RouterView></RouterView></div>",
        };
      },
      header,
    },
    meta: {
      menu: true,
      back: true,
    },
  },
  // {
  //   path: "/h/:pathMatch(.*)*",
  //   name: "hallShareLink",
  //   alias: "",
  //   redirect: (to) => {
  //     return "/workplace/hall/hallDetails/" + to.params.id;
  //   },
  // },
  {
    path: "/s/:pathMatch(.*)*",
    name: "share",
    redirect: "/workplace",
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "404",
  //   components: {
  //     default: () => import("@/views/404.vue"),
  //   },
  // },
];

routes.push(workplace);

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.afterEach((to, from) => {
  const user = userStore();
  if (!user.token && to.meta.requiresAuth !== false) {
    ElMessage({ type: "error", grouping: true, message: "请先登录" });
    login();
    return false;
  }
});

export default router;
